

var _core = require('../core');

var _env = require('./env');

_core.$config.deploy = _core.$config.deploy || _env.$env;

_core.$config;

_env.$env;


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/paypal/config.js
// module id = ../node_modules/squid/dist/paypal/config.js
// module chunks = 0